import actions from "./queueActions";

const initialState = {
  queue: {},
  tracks: {},
  isLoadingQueue: true,
  isTracksLoading: false,
};

export const STATE_KEY = "queue";

const queueReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.START_LOAD_TRACKS_REQUEST:
      return {
        ...state,
        isTracksLoading: true,
      };
    case actions.END_LOAD_TRACKS_REQUEST:
      return {
        ...state,
        isTracksLoading: false,
      };
    case actions.SUCCESS_LOAD_TRACKS_REQUEST:
      return {
        ...state,
        isLoadingQueue: false,
        tracks: {
          ...state.tracks,
          ...action.payload.tracks.reduce((acc, track) => {
            acc[track.uri] = track;
            return acc;
          }, {}),
        },
      };
    default:
      return state;
  }
};

export default queueReducer;
